module.exports = __webpack_public_path__ + "media/wymagane_pole.513599eb.mp3";